import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
    container: {
        width: '90%',
        height: 25,
        flexDirection: 'row',
        alignItems: 'center',
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: '#FFFFFF',
        borderRadius: 5,
        backgroundColor: '#FFFFFF',
    },
    minInvestContainer: {
        height: 21,
        width: '66.6%',
        borderRadius: 5,
        backgroundColor: '#FFFFFF',
    },
    minInvestFill: {
        height: 21,
        width: 0,
        backgroundColor: '#FFCC3C',
    },
    maxInvestContainer: {
        height: 21,
        width: '33.3%',
        borderRadius: 5,
    },
    maxInvestFill: {
        height: 21,
        width: 0,
        backgroundColor: 'rgb(255, 169, 59)',
    },
});